// src/ProjectContext.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

const ProjectContext = createContext();

export const useProject = () => useContext(ProjectContext);

export const ProjectProvider = ({ children }) => {
  const [activeProject, setActiveProject] = useState(null);

  // useEffect(() => {
  //   const stored = localStorage.getItem("activeProject");
  //   if (stored) {
  //     try {
  //       setActiveProject(JSON.parse(stored));
  //     } catch {
  //       setActiveProject(stored);
  //     }
  //   }
  // }, []);

  const selectProject = (project) => {
    setActiveProject(project);
    // localStorage.setItem("activeProject", JSON.stringify(project));
  };

  const clearProject = () => {
    setActiveProject(null);
    // localStorage.removeItem("activeProject");
  };

  return (
    <ProjectContext.Provider value={{ activeProject, selectProject, clearProject  }}>
      {children}
    </ProjectContext.Provider>
  );
};
